export interface BadgeColor {
    bg: string,
    text: string,
    ring: string,
    icon?: string | null,
}

export default function Badge({label, color, className}: { label: string, color: BadgeColor, className?: string }) {
    return (
        <span
            className={`inline-flex items-center rounded-full ${color.bg} px-2 py-1 text-xs font-medium ${color.text} ring-1 ring-inset ${color.ring} ${className}`}>
        {label}
      </span>
    );

}